module.exports = __webpack_public_path__ + "index_pc/media/exp_tip_01_normal.87f92564.aac";